/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
// Unused imports from original file kept for consistency if needed, though they seem unused in render
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { Link } from 'react-router-dom';
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';

const styles = () => ({
    root: {
        padding: 20,
    },
    formControl: {
        minWidth: '100%',
    },
    sectionTitle: {
        fontSize: 19,
        color: '#174a84',
    },
    checkboxDividerLabel: {
        marginTop: 10,
        marginLeft: 5,
        marginRight: 20,
        fontSize: 16,
        fontWeight: 600
    },
    rootProgress: {
        width: '100%',
        textAlign: 'center',
    },
});

const useStyles = makeStyles(styles);

function isEmpty(obj) {
    if (obj == null) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}

const NewAdmission = () => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [newAppliedFor, setNewAppliedFor] = useState("");
    const [degreeData, setDegreeData] = useState([]);

    // Unused state from original component kept commented out or removed if strictly unused. 
    // successDialog was unused. 
    // isLoginMenu was used in error handler but not initialized in state and not rendered.

    useEffect(() => {
        getDegreesData();
    }, []);

    const getDegreesData = async () => {
        let data = [];
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsDegreeProgramsView`;
        try {
            const res = await fetch(url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
            });
            if (!res.ok) throw res;

            const json = await res.json();
            const resData = json.DATA || [];
            if (resData.length > 0) {
                for (let i = 0; i < resData.length; i++) {
                    if (!isEmpty(resData[i])) {
                        data.push({ id: "", label: resData[i].department });
                    }
                    for (let j = 0; j < resData[i].degrees.length; j++) {
                        if (!isEmpty(resData[i].degrees[j])) {
                            data.push({ id: resData[i].degrees[j].id, label: resData[i].degrees[j].label });
                        }
                    }
                }
            }
        } catch (error) {
            console.log('myData', error);
        }
        setDegreeData(data);
    };

    const handleChange = (e) => {
        const { value } = e.target;
        // console.log(name, value);
        setNewAppliedFor(value);
    };

    const onFormSubmit = async () => {
        if (newAppliedFor == null || newAppliedFor === "") {
            alert("Programme is required");
            return false;
        }

        const data = new FormData();
        data.append("degreeId", newAppliedFor);
        setIsLoading(true);

        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectNewApplication`;

        try {
            const res = await fetch(url, {
                method: "POST",
                body: data,
                headers: new Headers({
                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
            });

            if (!res.ok) throw res;

            const json = await res.json();
            if (json.CODE === 1) {
                alert("Your degree has been changed. Please fill the form.");
                window.localStorage.setItem("isSubmitted", 0);
                window.localStorage.setItem("isDocumentRequested", 0);
                window.localStorage.setItem("isPreviousSessionStudent", 0);
                window.location.replace("#/dashboard/admission-application");
                window.location.reload();
            } else {
                alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
            }
            console.log(json);

        } catch (error) {
            if (error.status == 401) {
                // Original code attempted to show login menu but failed to render it or init state.
                // We'll log it.
                console.log("Unauthorized access - session might be expired.");
            } else {
                console.log(error);
                alert("Failed to Save ! Please try Again later.");
            }
        }
        setIsLoading(false);
    };

    return (
        <Fragment>
            <Grid container component="main" className={classes.root}>
                <Typography style={{
                    color: '#1d5f98',
                    fontWeight: 600,
                    borderBottom: '1px solid #d2d2d2',
                    width: '98%',
                    marginBottom: 25,
                    fontSize: 20,
                }} variant="h5">
                    New Admission
                </Typography>
                <Divider style={{
                    backgroundColor: 'rgb(58, 127, 187)',
                    opacity: '0.3'
                }} />
                <Grid container spacing={2} style={{ marginLeft: 5, marginRight: 10 }}>
                    <Grid xs={12}>
                        <span className={classes.sectionTitle}>
                            Course Applied For
                        </span>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="newAppliedFor">Programme</InputLabel>
                            <Select
                                name="newAppliedFor"
                                id="newAppliedFor"
                                value={newAppliedFor} // Changed from this.state.newAppliedFor (which was controlled manually inhandleChange in original code: this.state.newAppliedFor = value. In React 19/hooks we use state)
                                // Only issue: in original code, value prop wasn't passed to Select? 
                                // Original: <Select name="newAppliedFor" id="newAppliedFor" onChange={this.handleChange}>
                                // It was uncontrolled or broken? 
                                // Ah, the original code had: this.state.newAppliedFor = value; in handleChange. 
                                // It did NOT call setState.
                                // So the Select component was NOT updating via state. 
                                // But Select usually needs a value prop to show selected value. 
                                // If it didn't have value prop, it defaults to empty/uncontrolled. 
                                // But `handleChange` modified `this.state` directly. This is bad React practice.
                                // We will fix it to be controlled: value={newAppliedFor}.
                                onChange={handleChange}
                            >
                                {degreeData.map((item, index) => {
                                    return (<MenuItem key={index} disabled={!item.id} value={item.id}>{item.label}</MenuItem>);
                                })}
                            </Select>
                        </FormControl>
                    </Grid>

                </Grid>
            </Grid>
            <Grid item xs={12} style={{ paddingBottom: 20, paddingTop: 20, display: 'flex' }} justifyContent="center">
                <Button disabled={isLoading} onClick={onFormSubmit} color="primary" variant="contained" style={{ width: '100%', backgroundColor: '#174A84' }}>
                    {isLoading ? <CircularProgress style={{ color: 'white' }} size={24} /> : "Save"}
                </Button>
            </Grid>
        </Fragment >
    );
};

export default NewAdmission;
